import mediaQuery from 'css-mediaquery';

/**
 * This function is used to simulate the behavior of window.matchMedia in a server-side rendering (SSR) environment.
 * It takes a media query string and a deviceChar object, and returns an object with a matches property.
 * The matches property indicates whether the media query matches the given device characteristics.
 *
 * @param {string} query - The media query string to evaluate.
 * @param {Record<string, string>} deviceChar - An object representing device characteristics.
 * @returns {{ matches: boolean }} - An object with a matches property indicating if the query matches.
 */

export const ssrMatchMedia = (
  query: string,
  deviceChar: Record<string, string>
): { matches: boolean } => {
  return {
    matches: mediaQuery.match(query, {
      // The estimated CSS width of the browser.
      width: deviceChar?.is_mobile === 'true' ? '1px' : '1400px',
    }),
  };
};
